"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
var react_1 = require("react");
var react_hook_form_1 = require("react-hook-form");
var RHFInput_1 = require("@components/base/RHFInput");
var Button_1 = require("@components/base/Button");
var login_1 = require("@domain/login");
var useLogin_1 = require("@store/login/useLogin");
var useBreakpoints_1 = require("@hooks/useBreakpoints");
var PasswordResetLink_1 = require("./PasswordResetLink");
var LoginButton = (0, styles_1.styled)(Button_1.ButtonLarge)(function () { return ({
    fontWeight: 500,
    fontSize: "16px",
    width: "100%",
    "&.Mui-disabled": {
        backgroundColor: "#C0D3DF",
    },
}); });
var styleOfWithoutLabelField = {
    "& fieldset": {
        top: 0,
    },
    "& legend": {
        display: "none",
    },
};
var LoginForm = function () {
    var _a = (0, react_1.useState)(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = (0, react_1.useState)(), encryptedShop = _b[0], setEncryptedShop = _b[1];
    var _c = (0, useLogin_1.useLogin)(), isDisabled = _c.isDisabled, csrfToken = _c.csrfToken, updateCsrfToken = _c.updateCsrfToken, updateInitializeUsername = _c.updateInitializeUsername;
    var isUnderXs = (0, useBreakpoints_1.useIsUnderXs)();
    var _d = (0, react_hook_form_1.useForm)({
        mode: "onChange",
        defaultValues: {
            username: updateInitializeUsername(),
            password: "",
        },
    }), control = _d.control, handleSubmit = _d.handleSubmit, _e = _d.formState, errors = _e.errors, isValid = _e.isValid;
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var form;
        return __generator(this, function (_a) {
            setIsSubmitting(true);
            form = document.getElementById("loginForm");
            if (form)
                form.submit();
            return [2 /*return*/];
        });
    }); };
    (0, react_1.useEffect)(function () {
        updateCsrfToken();
        var element = document.getElementById("app");
        if (element) {
            var dataEncryptedShop = element.dataset.encryptedShop;
            if (dataEncryptedShop) {
                setEncryptedShop(dataEncryptedShop);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- 暫定対応
    }, []);
    return ((0, jsx_runtime_1.jsxs)("form", { id: "loginForm", action: "/admin/auth/login", method: "post", onSubmit: handleSubmit(onSubmit), style: { width: "100%" }, children: [(0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "_token", value: csrfToken }), encryptedShop && ((0, jsx_runtime_1.jsx)("input", { type: "hidden", name: "encrypted_shop", value: encryptedShop })), (0, jsx_runtime_1.jsx)(Box_1.default, { mt: "18px", sx: styleOfWithoutLabelField, children: (0, jsx_runtime_1.jsx)(RHFInput_1.RHFMailField, { name: "username", placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", control: control, validationRules: login_1.validationRules.username }) }), (0, jsx_runtime_1.jsx)(Box_1.default, { mt: "18px", sx: styleOfWithoutLabelField, children: (0, jsx_runtime_1.jsx)(RHFInput_1.RHFPasswordField, { name: "password", placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044", control: control, validationRules: login_1.validationRules.password }) }), (0, jsx_runtime_1.jsx)(Box_1.default, { mt: 1, children: (0, jsx_runtime_1.jsx)(PasswordResetLink_1.PasswordResetLink, {}) }), (0, jsx_runtime_1.jsx)(Box_1.default, { mt: 6, sx: { textAlign: "center" }, children: (0, jsx_runtime_1.jsx)(LoginButton, { style: {
                        fontWeight: 500,
                        fontSize: "16px",
                        maxWidth: isUnderXs ? "100%" : "400px",
                    }, disabled: isDisabled(isValid, isSubmitting, errors), type: "submit", form: "loginForm", children: "\u30ED\u30B0\u30A4\u30F3" }) })] }));
};
exports.LoginForm = LoginForm;
